export default __webpack_public_path__ + "static/media/Icons_13.f488dae8.svg";